<template>
  <div v-if="action">
    <label :for="`input-file-${action.id}`">
      <!-- {{ $t("action_plan.viewer.comments") }} -->
      Archivos
    </label>
    <vue-dropzone
      :id="`dp_${action.id}`"
      :ref="`dp_${action.id}`"
      class="dropzone-main dropzone-action-plan"
      :options="dropzoneOptions"
      :include-styling="false"
      :use-custom-slot="true"
      @vdropzone-success="addFile"
      @vdropzone-removed-file="removeFile"
      @vdropzone-max-files-exceeded="maxFilesExceeded"
      v-if="showDropzone"
    >
      <div class="dropzone-custom-content">
        <p class="dropzone-custom-title text-center mt-2 mb-0">Arrastra y suelta o haz click para añadir hasta 3 archivos</p>
      </div>
    </vue-dropzone>
    <div v-else>
      <a v-for="(file, index) in files" :key="index" class="d-block"
         target="_blank"
         :href="file.url">
        <span class="feather icon-download"></span>
        {{ file.name }}
      </a>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: "Files",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    actionPlanLogUuid: String,
    action: Object,
    value: Object | Array,
    terminated: Boolean,
    validating: Boolean,
    preview: Boolean,
  },
  data() {
    return {
      allowRemoveFiles: true,
      dropzoneOptions: {
        url: `${window.__env.VUE_APP_BASE_URL}/v1/action_plan/upload-files`,
        headers: this.headers(),
        maxFiles: 3,
        paramName: "file",
        addRemoveLinks: true,
        dictRemoveFile: this.$t("actions.delete"),
        previewTemplate: this.template(),
        params: (files, xhr, chunk) => {
          return {
            name: files[0].name,
            type: files[0].type,
            action_plan_log_uuid: this.actionPlanLogUuid,
            path: `action_plan_logs/${this.actionPlanLogUuid}`,
          }
        }
      },
      files: []
    }
  },
  mounted() {
    this.files = this.value || [];

    if (this.showDropzone) {
      this.files.forEach(file => {
        this.$refs[`dp_${this.action.id}`].manuallyAddFile(file, '');
      });
    }
  },
  computed: {
    showDropzone() {
      return (this.validating || this.preview || this.terminated) === false;
    }
  },
  watch: {
    showDropzone() {
      this.allowRemoveFiles = false;
    }
  },
  methods: {
    template() {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-details">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <!--<div class="dz-success-mark"><i class="feather icon-check"></i></div>-->
                <!--<div class="dz-error-mark"><i class="feather icon-x-circle"></i></div>-->
                <a href="#" data-dz-remove>
                    <span class="feather icon-x-circle"></span>
                </a>
            </div>
        `;
    },
    addFile(file, response) {
      if (file.status === 'success' && response.success) {
        const url = response.data.data.Url;
        this.files.push(this.normalizeFile(file, url))
        this.updateFiles();
      }
    },
    removeFile(file) {
      this.$nextTick(() => {
        if (!this.allowRemoveFiles) return;

        const index = this.files.findIndex((f) => f.id === file.upload.uuid);

        if (index > -1) {
          this.files.splice(index, 1);
        }

        this.updateFiles();
      });
    },
    maxFilesExceeded(file) {
      this.$refs[`dp_${this.action.id}`].removeFile(file);
    },
    normalizeFile(file, url) {
      return {
        id: file.upload.uuid,
        name: file.upload.filename,
        size: file.size,
        type: file.type,
        timestamp: file.lastModified,
        url,
      }
    },
    updateFiles() {
      const _files = this.files;
      this.$emit('input', _files);
      this.$emit('files-changed');
    },
    headers() {
      const token = localStorage.getItem("accessToken");
      return {
        Authorization: `Bearer ${token}`,
      };
    },
  }
}
</script>

<style lang="scss">
.dropzone-action-plan {
  &.dropzone-main {
    width: 100%;
    height: auto;
    min-height: 3vw;
    border: 1px dashed #0099ff;
  }

  .dz-preview {
    display: inline-block;
    border: 1px dashed #0099ff;
    margin: 10px 5px !important;
    padding: 5px;
    text-align: center;
    width: 140px;
    transition: 1s background-color;

    .dz-image {
      display: none;
      width: 80px;
      height: 80px;
      margin-left: 40px;
      margin-bottom: 10px;

      & > div {
        width: inherit;
        height: inherit;
        border-radius: 50%;
        background-size: contain;
      }
    }

    .dz-filename {
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .dz-remove {
      display: none;
    }

    [data-dz-remove] {
      color: red;
    }

    &.dz-processing {
      background-color: rgba(#0099ff, 0.3);
    }

    &.dz-success {
      background-color: transparent;
    }

    &.dz-error {
      background-color: rgba(red, 0.3);
    }

    // &.dz-complete {}
  }
}
</style>
